import SignUp from '@src/pageComponents/SignUp';
import React from 'react';

const SubscribePage = () => <SignUp step="subscribe" />;

export default SubscribePage;
